<template>
  <header>
  <nav class="w-100">
            <div class="container">
                <div class="nav-content d-flex w-100 align-items-center">
                    <img style="width: 72px;height: 71px;" src="@/assets/image/navlogo.png">
                    <div class="nav-right d-flex align-items-center">
                        <router-link to="/dashboard" class="nav-contact-link"><span>{{name}}</span>Dashboard</router-link>
                        <a style="cursor: pointer;" @click="logout()" class="nav-contact-link">Logout</a>
                    </div>
                </div>
            </div>
        </nav>
  </header>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      name: '',
      token: ''
    }
  },
  methods: {
    async logout () {
      // console.log('hgh')
      // axios
      //   .post('https://api.foojan.com/auth/logout', {
      //     platform: 3
      //   })
      //   .then((response) => {
      //   this.email = ''
      //   this.password = ''
      // console.log(response)
      localStorage.removeItem('api_token')
      localStorage.setItem('isAuth', false)
      this.$router.push({ path: '/home' })
      // })
      // .catch((error) => {
      //   console.log('error', error.response.data.message)
      // })
    }
  },
  mounted: function () {
    this.user_id = localStorage.getItem('user_id')
    this.token = localStorage.getItem('api_token')
    axios.get(process.env.VUE_APP_WEBAPP_URL + '/auth/getUser/', {
      headers: {
        Authorization: 'Bearer ' + this.token
      }
      // params: {
      //   id: this.user_id
      // }
    }).then((response) => {
      this.name = response.data.data.first_name.charAt(0)
    }).catch((error) => {
      console.log(error)
    })
  }
}

</script>
